<template>
    <div class="page-sign">
        <!-- <p class="marquee" behavior="infinite" direction="left">
            <marquee>通知：近期功能升级，喂养小马功能需暂时下线，您的小马能量已按照1:1比例自动兑换为积分充值进已登录的账户，您可前往积分明细中查看，如有疑问，请拔打客服电话1010-9955。</marquee>
        </p>-->
        <section class="sign-box" v-if="signStatus">
            <div class="help" @click="showHelpDialog">
                <img src="../assets/images/sign/icon_help.png" alt />
                <span v-ilog="`${ilog.t7}.0`">帮助</span>
            </div>
            <a
                v-if="startActivity && startActivity.start"
                :href="startActivity.imgHref"
                class="prize"
            >
                <img :src="startActivity.imgUrl" width="100%" alt />
            </a>
            <div id="pan" class="pan"></div>
            <div class="sign-tpl">
                <div class="tit">- 已连续签到 -</div>
                <div class="days">
                    <span class="number">{{ totalDay }}</span>
                    <i>天</i>
                </div>
                <div class="integral">已有{{ signStatus.userPoint }}积分</div>
                <div v-if="signStatus.todayTask">
                    <div class="sign-btn active" v-ilog="ilog.t2" @click="goTask">
                        随机任务
                        <img src="../assets/images/sign/icon_arrow.png" width="100%" alt />
                    </div>
                    <div class="desc">
                        <p>明日签到 +{{ signStatus.tomorrowPoint }} 积分</p>
                    </div>
                </div>
                <div v-else-if="!signStatus.currentFlag">
                    <div class="sign-btn" v-ilog="ilog.t1" @click="signing">签到</div>
                    <div class="desc">
                        <p>今日签到 +{{ signStatus.todayPoint }} 积分</p>
                    </div>
                </div>
                <div class v-else>
                    <div class="sign-btn active">今日已签到</div>
                    <div class="desc">
                        <p>明日签到 +{{ signStatus.tomorrowPoint }} 积分</p>
                    </div>
                </div>
            </div>
        </section>
        <section
            class="activity-box"
            :class="cmsProductList.length > 1 ? 'activity-box-on' : ''"
            v-if="cmsProductList.length"
        >
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div
                        class="swiper-slide"
                        v-for="(item, index) in cmsProductList"
                        :key="item.id"
                    >
                        <a :data-index="index" :href="item.link" class="block">
                            <div class="activity-item">
                                <span class="mask-ilog" v-ilog="`${item.ilog}.0`"></span>
                                <img :src="item.img" alt />
                            </div>
                        </a>
                    </div>
                </div>
                <div
                    class="swiper-pagination"
                    style="display: flex;align-items: center;text-align: center;justify-content: center;height: 0.25rem;z-index: 102;"
                ></div>
            </div>
        </section>
        <section class="area-box" v-if="primePoint">
            <a :href="primePoint.attributes.jfUrl">
                <div class="area-tit">
                    <h5>积分专区</h5>
                    <a :href="primePoint.map.jfUrl" v-ilog="ilog.t3" class="more">
                        我的积分
                        <span>{{ signStatus.userPoint }}</span>
                        <img src="../assets/images/sign/icon_arrow-right.png" alt />
                    </a>
                </div>
            </a>
        </section>
        <div class="line-product"></div>
        <section class="product-box" v-if="primeCms">
            <div
                class="product-item"
                :class="(index+1)%2?'fl':'fr'"
                v-for="(item , index) in primeCms"
                v-bind:key="index"
                @click="openUrl(item.url)"
            >
                <span class="mask-ilog" v-ilog="`${item.ilog}.0`"></span>
                <!-- <a :href="item.url"> -->
                <!-- <div class="product-tit">
                        <h6 v-if="item.title">
                            <span>{{item.title}}<i v-if="item.hotflag">限量</i></span>
                        </h6>
                        <div>{{item.desc}}</div>
                </div>-->
                <div class="product-icon">
                    <img :src="item.img" alt />
                </div>
                <!-- </a> -->
            </div>
        </section>

        <section class="task-box" v-if="marketList">
            <div class="task-tit">
                <h5>
                    积分商城 &nbsp;
                    <span class="xshw-task" style="color: #E7E7E7;">心水好物</span>
                </h5>
                <a
                    href="https://static.zhongan.com/website/assets/subject/react/jifenmall/index.html"
                    v-ilog="ilog.t8"
                    class="more"
                >
                    更多好物
                    <img src="../assets/images/sign/icon_arrow-right.png" alt />
                </a>
            </div>

            <div class="task-list">
                <ul>
                    <li v-for="(item , index) in marketList" v-bind:key="index">
                        <a :href="item.url">
                            <div class="img">
                                <span class="mask-ilog" v-ilog="`${item.ilog}.0`"></span>
                                <img :src="item.img" width="100%" alt />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </section>

        <Help-dialog @cancel="cancelDialog" :showDialog="showHelp"></Help-dialog>
        <Task-dialog @cancel="cancelDialog" :showData="dataTaskDialog"></Task-dialog>
        <Sign-dialog @finish="FinishTask" @cancel="cancelDialog" :showData="dataSignDialog"></Sign-dialog>
        <LoginDialog @cancel="cancelDialog" :showLoginDialog="showLogin"></LoginDialog>
    </div>
</template>

<script>
import Axios from 'axios'
import * as Swiper from 'swiper/dist/js/swiper.js'
import dmSSO from '@dm/sso'

const axios = Axios.create({
    timeout: 50000,
    withCredentials: true
})

import HelpDialog from './components/Help-dialog.vue'
import TaskDialog from './components/Task-dialog.vue'
import SignDialog from './components/Sign-dialog.vue'
import LoginDialog from './components/Login-dialog.vue'

import service from '../api/service'

const resourceCode1 = 'qdBanner'
const ilogConfig = {
    wechat: {
        t1: '2.922.hM5',
        t2: '2.922.jI0',
        t3: '2.922.hhBr',
        t4: '2.922.eM8',
        t5: '2.924.uY0',
        t6: '2.925.oW2',
        t7: '2.922.Owmt',
        t8: '2.922.xD0'
    },
    app: {
        t1: '8.926.uL3',
        t2: '8.926.xZ6',
        t3: '8.926.RZ9G',
        t4: '8.926.fR6',
        t5: '8.927.sL3',
        t6: '8.928.xJ4',
        t7: '8.926.52aO',
        t8: '8.926.mL7'
    }
}

let iconfig
let slider
let elSlider
let sso

if (_zax.device.app) {
    iconfig = ilogConfig['app']
} else if (_zax.device.weixin) {
    iconfig = ilogConfig['wechat']
} else {
    iconfig = ilogConfig['wechat']
}

window['globalLoginFunc'] = function(res) {
    console.log('globalLoginFunc', res)
    location.reload()
}

window['globalFuncX'] = function(res) {
    console.log('globalFuncX', res)
}

const chartOption = {
    series: [
        {
            type: 'gauge',
            center: ['50%', '46%'],
            min: 0,
            max: 6,
            splitNumber: 6,
            radius: '75%',
            axisLine: {
                // 坐标轴线
                lineStyle: {
                    color: [[0, '#fff'], [1, '#88e1db']],
                    width: 5, //内围线宽
                    shadowColor: '#fff',
                    shadowBlur: 4
                }
            },
            axisLabel: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            pointer: {
                show: false
            },
            title: {
                show: false
            },
            detail: {
                show: false
            }
            //data: [{ value: 5, name: 'week' }]
        },

        {
            name: 'month',
            center: ['50%', '46%'],
            type: 'gauge',
            min: 0,
            max: 3,
            splitNumber: 3,
            radius: '85%',

            axisLine: {
                // 坐标轴线
                lineStyle: {
                    color: [[0, '#fff'], [1, '#88e1db']],
                    width: 0
                }
            },
            axisLabel: {
                show: false
            },
            axisTick: {
                // 坐标轴小标记
                splitNumber: 28, //分隔26块  25条线
                length: 8, //外围线高度
                lineStyle: {
                    width: 2, //外围线宽
                    color: 'auto',
                    shadowColor: '#fff',
                    shadowBlur: 3
                }
            },
            splitLine: {
                // 分隔线
                showMinLabel: false,
                length: -8,
                lineStyle: {
                    width: 2,
                    color: 'auto',
                    shadowColor: '#fff',
                    shadowBlur: 3
                }
            },
            pointer: {
                show: false
            },
            title: {
                show: false
            },
            detail: {
                show: false
            }
        }
    ]
}

export default {
    data() {
        return {
            swiperOptions: {
                pagination: '.swiper-pagination',
                paginationType: 'bullets',
                observeParents: true,
                observer: true,
                loop: true,
                autoplay: 3000
            },
            showHelp: false,
            showLogin: false,
            signStatus: false,
            marketList: false,
            taskStatus: null,
            signStatusCheck: false,
            dataSignDialog: {
                show: false,
                data: null
            },
            dataTaskDialog: {
                show: false,
                data: null
            },
            ilog: iconfig,
            startActivity: null,
            primePoint: null,
            primeCms: null,
            accountId: 0,
            userCredit: {},

            cmsProductList: []
        }
    },
    beforeMount() {
        // if (_zax.device.app) {
        //   window.prompt(
        //     JSON.stringify({
        //       functionName: "resetNavigationBar",
        //       params: { resetArray: ["titleColor"] },
        //       complete: "func"
        //     })
        //   ); //  兼容跳转到打卡活动titlebar重置
        // }
        // this.getSignStatus();
        // this.FindPointActivity();
        // this.getActivity();
        // let redirectPath={
        //     testing:'https://dm-test.zhongan.com/m1/u-member/signIn?bizOrigin=qiandao',
        //     development:'https://dm-uat.zhongan.com/m/u-member/signIn?bizOrigin=qiandao',
        //     production:'https://dm.zhongan.com/m/u-member/signIn?bizOrigin=qiandao'
        // };
        document.location.replace('https://dm.zhongan.com/m/u-member/signIn?bizOrigin=qiandao')
    },
    computed: {
        totalDay() {
            if (this.signStatus) {
                let str = '000000' + this.signStatus.continuityNum
                return str.substr(str.length - 3)
            } else {
                return '000'
            }
        }
    },
    methods: {
        _initPage() {
            if (_zax.device.app) {
                window.prompt(
                    JSON.stringify({
                        functionName: 'resetNavigationBar',
                        params: { resetArray: ['titleColor'] },
                        complete: 'globalFuncX'
                    })
                ) //  兼容跳转到打卡活动titlebar重置
            }

            this._initSlider()
            elSlider = $('#dm-af-slider')

            this.getSignStatus()
            this.FindPointActivity()

            this.getActivity()

            document.title = '每日签到'

            if (_zax.device.app) {
                window.bridge &&
                    window.bridge.ready(boot => {
                        boot.onJSInvokeResult('1', '每日签到')
                    })
            }

            service.getProductByCode('qdBanner').then(
                res => {
                    if (res.data.length <= 1) {
                        this.swiperOptions = { ...this.swiperOptions, loop: false }
                    }

                    this.cmsProductList = res.data.map(item => {
                        let { appmd, h5md, wxmd } = item
                        let ilog = appmd || h5md
                        if (!_zax.device.app) {
                            ilog = wxmd
                        }
                        return { ...item, ilog }
                    })

                    setTimeout(() => {
                        var swiper = new Swiper('.swiper-container', {
                            loop: true,
                            autoplay: {
                                delay: 5000
                            },
                            pagination: {
                                el: '.swiper-pagination'
                            }
                        })
                    }, 300)
                },
                err => {
                    console.log(err)
                }
            )

            service.getProductByCode('app_qd_point_lottery').then(
                res => {
                    this.primeCms = res.data.map((item, index) => {
                        let { gotoUrl: url, imageUrl: img, appmd, wxmd } = item
                        let ilog = appmd
                        if (!_zax.device.app) {
                            ilog = wxmd
                        }
                        return { url, img, ilog }
                    })
                },
                err => {
                    console.log(err)
                }
            )

            service.QueryUserPointInfo().then(res => {
                if (res && res.obj && res.obj.accountId) {
                    let { accountId } = res.obj
                    service.GetPrimePoint(accountId).then(data => {
                        this.primePoint = data
                    })
                }
            })

            // service.GetPrimeBanner('app_point_lottery').then((data) => {
            // this.primeCms = data.rows.map((item, index) => {
            //     let {materialId, title, url, img} = item;
            //     let desc = '';
            //     let hotflag = false;
            //     if (materialId == 1021326) {
            //         desc = '积分抽豪礼'
            //     } else if (materialId == 1021328) {
            //         desc = '239兑换2元，仅限APP内'
            //         if(!_zax.device.app){
            //             url = 'https://static.zhongan.com/website/app/html/downLoadLink/build/html/index.html?channel=ZY_WXQDHBXZ&source=HBXZ';
            //         }
            //         hotflag = true
            //     }
            //     return {materialId, title, url, hotflag, desc, img}
            // });

            // })
            service.getUserCredit().then(res => {
                if (res.success && res.obj) {
                    this.userCredit = res.obj
                }
            })
        },
        showPan(daydays, monthdays) {
            $('#pan').remove()
            $('.sign-box').prepend('<div class="pan" id="pan"></div>') //iphone5 wechat hack
            let myChart = echarts.init(document.getElementById('pan'))
            chartOption.series[1].axisLine.lineStyle.color[0][0] = monthdays / 28
            chartOption.series[0].axisLine.lineStyle.color[0][0] = daydays / 7
            myChart.setOption(chartOption)
        },
        openUrl(url) {
            location.href = url
        },
        // 获取签到历史记录
        getSignStatus() {
            service.GetSignHistory().then(
                data => {
                    this.signStatus = data
                    this.signStatusCheck = false
                    this.$nextTick(() => {
                        let day, month
                        if (data.periodNum) {
                            day = data.periodNum % 7 || 7
                        } else {
                            day = 0
                        }
                        if (data.continuityNum) {
                            month = data.continuityNum % 28 || 28
                        } else {
                            month = 0
                        }
                        this.showPan(day, month)
                        // !slider && elSlider.show();
                    })

                    if (data.todayTask) {
                        this.GetTask()
                    }
                },
                e => {
                    console.log(e)
                }
            )
        },

        getActivity() {
            service.getActivity().then(
                data => {
                    if (data.success) {
                        this.startActivity = data.obj
                    }
                },
                e => {
                    console.log(e)
                }
            )
        },

        FindPointActivity() {
            // service.GetPrimeBanner('app_point_mart').then((data) => {
            // this.marketList = data.rows.map((item, index) => {
            //     let {materialId, title, url, img} = item;
            //     return {materialId, title, url, img}
            // });
            // })
            service.getProductByCode('app_qd_point_mart').then(
                res => {
                    this.marketList = res.data.map((item, index) => {
                        let { gotoUrl: url, imageUrl: img, appmd, wxmd } = item
                        let ilog = appmd
                        if (!_zax.device.app) {
                            ilog = wxmd
                        }
                        return { url, img, ilog }
                    })
                },
                err => {
                    console.log(err)
                }
            )
        },
        //点击签到
        signing() {
            if (!_zax.cookie.get('zaLoginCookieKey')) {
                // _zax.ui.mask.show()
                // this.showLoginDialog()
                if (_zax.device.app) {
                    window.prompt(
                        JSON.stringify({
                            functionName: 'login',
                            params: { url: window.location.href },
                            complete: 'globalLoginFunc'
                        })
                    )
                } else {
                    sso.pop()
                }
                return
            }
            let { userCredit } = this

            this.doApiSignIn()

            // return

            // if (userCredit === 'G' || userCredit === 'N') {
            //     console.log(666666, userCredit, slider)
            //     slider && slider.startAnalyze() // 自动调用analyze api
            // } else {
            //     console.log(767676767676, userCredit)
            //     this.doApiSignIn()
            // }
        },

        doApiSignIn(param = {}) {
            if (this.signStatusCheck) {
                return
            }
            this.signStatusCheck = true
            service.SignIn(param).then(
                data => {
                    //   console.log(22222222, data, data.obj, data.obj.value);
                    if (data.success) {
                        this.getSignStatus()

                        //B 黑名单 W 白名单 G 灰名单 需要弹滑块 Y 滑块验证通过 N 滑块验证不通过
                    } else if (data.obj && (data.obj.value == 'G' || data.obj.value == 'B' || data.obj.value == 'N')) {
                        this.signStatusCheck = false
                        console.log(333333333333, data, data.obj, data.obj.value)
                        // _zax.ui.toast(data.returnMsg || data.msg || data.returnMessage || '服务异常')
                        // slider && slider.startAnalyze(); // 自动调用analyze api
                        this._initPage()
                        elSlider.show()
                    } else {
                        // console.log(44444444, data.returnMsg || data.msg);
                        _zax.ui.toast(data.returnMsg || data.msg || data.returnMessage || '服务异常')
                        this.signStatusCheck = false
                    }
                },
                e => {
                    console.log(e)
                }
            )
        },

        GetTask() {
            service.GetTask().then(
                data => {
                    if (data.success) {
                        this.taskStatus = data
                    }
                },
                e => {
                    console.log(e)
                }
            )
        },

        goTask() {
            if (this.taskStatus.obj.taskStatus === 'PENDING' || this.taskStatus.obj.taskStatus === 'DOING') {
                this.dataSignDialog.show = true
                this.dataSignDialog.data = this.taskStatus.obj
                this.dataSignDialog.data.ilog = this.ilog.t6
            } else {
                this.dataTaskDialog.show = true
                this.dataTaskDialog.data = this.taskStatus.obj
            }
        },

        FinishTask() {
            if (this.taskStatus.obj.taskStatus === 'PENDING') {
                this.dataSignDialog.show = false
                return
            }
            service.FinishTask(this.taskStatus.obj.code).then(
                data => {
                    if (data.success) {
                        this.dataTaskDialog.show = true
                        this.dataTaskDialog.data = data.obj
                        this.getSignStatus()
                    } else {
                        _zax.ui.toast(data.msg || data.returnMsg || data.returnMessage || '服务异常')
                    }
                    this.dataSignDialog.show = false
                },
                e => {
                    console.log(e)
                }
            )
        },

        showHelpDialog() {
            this.showHelp = true
        },
        showLoginDialog() {
            this.showLogin = true
        },

        cancelDialog(target) {
            if (target == 'help') {
                this.showHelp = false
            } else if (target == 'sign') {
                this.dataSignDialog.show = false
            } else if (target == 'login') {
                this.showLogin = false
            } else {
                this.dataTaskDialog.show = false
            }
        },

        _initSlider() {
            let hostPrefix = location.host.indexOf('staticdaily') > -1
            slider = new ClickIdentifyControl({
                modal: true,
                container: '#dm-af-slider',
                // token: `4ad80630-d276-11e8-9e94-0a58ac145018`,
                sId: `af-dm-activity#prd#fraud_img`,
                host: `https://${hostPrefix ? 'test-' : ''}af.zhongan.io`,
                // riskhost: "https://dataantibot-pre.zhongan.com",
                // dunkeyhost: `https://${process.env.NODE_ENV === 'development' ? 'test-' : ''}af.zhongan.io`,
                placeholdLabel: '检验中',
                // useRisk: true,
                timeout: 22,
                onDunkeyLoad: function() {
                    console.log('onDunkeyLoad')
                },
                onFetchError: function(e) {
                    console.log('error', e)
                },
                onClickStartAnalyze: function() {
                    // setUserInfo();
                    console.log('onClickStartAnalyze')
                },
                onOpenDialog: function() {
                    console.log('openDialog')
                },
                onCloseDialog: function() {
                    console.log('closeDialog')
                    slider && slider.destroy()
                    elSlider.hide()
                },
                onPacmanComplete: function() {
                    console.log('onpacman complete')
                },
                onSuccess: (did, token, sId) => {
                    console.log('onSuccess ====', did, token, sId)
                    slider && slider.destroy()
                    elSlider.hide()
                    // sId = sId + '00000';
                    // did = did + '00000';
                    // token = token + '00000';
                    this.doApiSignIn({
                        did,
                        token,
                        sId
                    })
                    // successCallback && successCallback({ did, token, sId })
                },
                onFail: function(res) {
                    console.log('fali', res)
                }
            })
            window.testSlider = slider
        }
    },
    mounted() {
        let me=this
        me._initPage()
        sso = new dmSSO({
            mode: 'single',
            loginCallback(self, res) {
                me._initPage()
            }
        })
    },
    destroyed() {
        let me = this
        slider && slider.destroy()
    },
    components: {
        HelpDialog,
        TaskDialog,
        SignDialog,
        LoginDialog
    }
}
</script>



// WEBPACK FOOTER //
// src/views/Sign.vue